
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-manga-generator",
      function () {
        return require("private-next-pages/ai-manga-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-manga-generator"])
      });
    }
  